<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
        v-model="activeTab"
      >
        <v-tab class="tabText" @click.prevent="setGetFavoritas(false, false, 0)" :key="0">
          Notícias
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === false && !loading && !pasta && data.totalItems > 0) }">
            {{ flg_favorita === false && !loading && !pasta && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
        <v-tab class="tabText" @click.prevent="setGetFavoritas(true, false, 0)" :key="1">
          Favoritas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === true && !loading && !pasta && data.totalItems > 0) }">
            {{ flg_favorita === true && !loading && !pasta && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
        <v-tab
          class="tabText"
          @click.prevent="setGetFavoritas(false, true, pastas[0]?.cod_pasta)"
          :key="2"
        >
          Pastas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === false && cod_pasta !== 0 && !loading && data.totalItems > 0) }">
            {{ flg_favorita === false && cod_pasta !== 0 && !loading && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            @keypress.enter="handleClickEnter"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-select
            v-if="activeTab === 0"
            v-model="selectedEditoriaPortal"
            :items="$store.state.portais.selectedPortal.editorias_portal"
            placeholder="Escolha a editoria"
            solo flat dense hide-details
            background-color="surface_tertiary"
            item-value="cod_editoria"
            item-text="dsc_editoria"
            @change="handleChangeEditoria"
            class="colab-dropdown"
          >
            <template v-slot:append-item>
              <v-list-item @click="resetSelection">
                <v-list-item-title>Escolha a editoria</v-list-item-title>
              </v-list-item>
            </template>
          </v-select>

          <v-select
            v-if="activeTab === 2"
            v-model="cod_pasta"
            :items="pastas"
            placeholder="Pasta"
            solo flat dense hide-details
            background-color="surface_tertiary"
            item-value="cod_pasta"
            item-text="dsc_nome_pasta"
            @change="changePastas(cod_pasta)"
            class="colab-dropdown"
          />
        </div>

        <div v-if="data" class="columnWrapper">
          <template v-if="data">
            <template>
              <div
                v-for="item in data.items"
                :key="item.cod_noticia"
                class="card-item-wrapper drag-source"
                :class="{ 'drag-source--dragging': draggingId === item.cod_noticia }"
                draggable
                @dragstart="startDrag($event, item)"
                @dragend="endDrag"
              >
                <CardNoticiaAprovada
                  :item="item"
                  :get-noticias-aprovadas="getNoticiasAprovadas"
                  :get-noticias-moderadas="getNoticiasModeradas"
                  :current-page="currentAprovadasPage"
                  :is-favorita-tab="flg_favorita"
                  :cod_pasta="cod_pasta"
                />
              </div>
            </template>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import CardNoticiaAprovada from "../Cards/Noticias/CardNoticiaAprovada.vue";
import { mapActions, mapGetters } from "vuex";
// import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { dragSourceMixin } from "@/mixins/dragAndDrop";
export default {
  mixins: [dragSourceMixin],
  components: {
    CardNoticiaAprovada,
  },
  props: {
    data: { type: [Array, Object] },
    showModal: Function,
    closeModal: Function,
    currentAprovadasPage: Number,
    cod_producao: Number,
    changePasta: Function,
  },
  data() {
    return {
      imagem_url: "",
      isModalFiltrosVisible: false,
      filtro_texto: "",
      flg_favorita: "",
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      debounce: null,
      loading: false,
      activeTab: 0,
      pasta: false,
      cod_pasta: 0,
      selectedEditoriaPortal: null,
      dragIdField: 'cod_noticia',
    };
  },
  beforeMount() {
    this.filtro_texto = localStorage.getItem("@socialcam/filtro_texto_noticia") || "";
    this.selectedEditoriaPortal =
      localStorage.getItem("@socialcam/cod_editoria_portal") || null;
    if (this.selectedEditoriaPortal) {
      this.setSelectedEditoriaPortal(this.selectedEditoriaPortal);
    }
    this.flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita_noticias")) || false;
    this.activeTab = this.flg_favorita ? 1 : 0;
    this.setFlgFavorita(this.flg_favorita);
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    filtros() {
      return localStorage.getItem("@socialcam/filtros") || "";
    },
    ...mapGetters({
      pastas: "pastas/getterPastas",
    }),
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  methods: {
    ...mapActions({
      getNoticiasAprovadas: "noticias/getNoticiasAprovadas",
      getNoticiasModeradas: "noticias/getNoticiasModeradas",
      setFlgFavorita: "noticias/setFlgFavorita",
      setFiltroAprovadas: "noticias/setFiltroAprovadas",
      setSelectedEditoriaPortal: "portais/setSelectedEditoriaPortal",
    }),
    async resetSelection() {
      this.selectedEditoriaPortal = null;
      this.setSelectedEditoriaPortal(this.selectedEditoriaPortal);
      localStorage.setItem("@socialcam/cod_editoria_portal", this.selectedEditoriaPortal);
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        page: this.currentAprovadasPage,
        size: this.size,
        filtro_texto: this.filtro_texto,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.selectedEditoriaPortal,
      });
    },
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    async handleClickEnter() {
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        page: this.currentAprovadasPage,
        size: this.size,
        filtro_texto: this.filtro_texto,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.selectedEditoriaPortal,
      });
    },
    async handleChangeEditoria() {
      localStorage.setItem("@socialcam/cod_editoria_portal", this.selectedEditoriaPortal);
      await this.setSelectedEditoriaPortal(this.selectedEditoriaPortal);
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        page: this.currentAprovadasPage,
        size: this.size,
        filtro_texto: this.filtro_texto,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.selectedEditoriaPortal,
      });
    },
    async changePastas(cod_pasta) {
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        page: this.currentAprovadasPage,
        size: this.size,
        filtro_texto: this.filtro_texto,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.selectedEditoriaPortal,
      });
      await this.changePasta(cod_pasta);
    },
    async setGetFavoritas(flg_favorita, pasta, cod_pasta) {
      this.flg_favorita = flg_favorita;
      this.pasta = pasta;
      this.cod_pasta = cod_pasta;
      this.changePasta(cod_pasta);
      this.$store.commit("pastas/setCodPasta", cod_pasta);
      this.$store.commit("pastas/setIsPastaAtiva", pasta);
      localStorage.setItem("@socialcam/flg_favorita", flg_favorita);
      localStorage.setItem("@socialcam/isPastaAtiva", pasta);
      localStorage.setItem("@socialcam/cod_pasta", cod_pasta);
      try {
        this.loading = true;
        localStorage.setItem("@socialcam/flg_favorita_noticias", flg_favorita);
        // const loadPage = this.flg_favorita ? 1 : this.currentAprovadasPage;
        await this.getNoticiasAprovadas({
          cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          flg_favorita,
          page: this.currentAprovadasPage,
          size: 5,
          filtro_texto: this.filtro_texto,
          cod_pasta,
          cod_editoria: this.selectedEditoriaPortal,
        });
      } catch (error) {
        return this.$toast.error("Não foi possível buscar as favoritas");
      } finally {
        this.loading = false;
      }
    },
    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_noticia", e);
      this.setFiltroAprovadas(e);

      clearTimeout(this.debounce);

      this.debounce = setTimeout(() => {
        this.getNoticiasAprovadas({
          cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          flg_favorita: this.$store.state.noticias.flg_favorita,
          page: this.currentAprovadasPage,
          size: 5,
          filtro_texto: this.filtro_texto,
          cod_editoria: this.selectedEditoriaPortal,
          cod_pasta: this.cod_pasta,
        });
      }, 1500);
    },
  },
  watch: {
    activeTab: function (newValue) {
      this.setFlgFavorita(newValue === 1 ? true : false);
    },
    "$store.state.portais.selectedPortal": async function (newVal, oldVal) {
      if (oldVal && newVal && String(oldVal.cod_portal) !== String(newVal.cod_portal)) {
        localStorage.setItem("@socialcam/cod_editoria_portal", null);
        this.selectedEditoriaPortal = null;
        this.setSelectedEditoriaPortal(this.selectedEditoriaPortal);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.v-text-field__details {
  display: none !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
